<template>
  <div>
    <Carousel
      :value="contentInfo"
      :numVisible="3"
      :numScroll="3"
      :responsiveOptions="responsiveOptions"
      :orientation = "horizontal"
    >
      <template #item="slotProps">
        <div class="single-courses-card style3" style="padding: 10px">
          <div class="courses-img">
            <router-link :to="slotProps.data.url"
              ><img :src="slotProps.data.image" alt="Image"
            /></router-link>
          </div>
          <div class="courses-content">
            <router-link :to="slotProps.data.url">
              <h3>{{ slotProps.data.name }}</h3>
            </router-link>
            <p>{{ slotProps.data.description }}</p>
          </div>
        </div>
      </template>
    </Carousel>
  </div>
</template>

<script>
import Carousel from "primevue/carousel";
export default {
  name: "CarousalCompTypeOne",
  components: {
    Carousel,
  },
  data() {
    return {
      responsiveOptions: [
        {
          breakpoint: "1024px",
          numVisible: 3,
          numScroll: 3,
        },
        {
          breakpoint: "600px",
          numVisible: 2,
          numScroll: 2,
        },
        {
          breakpoint: "480px",
          numVisible: 1,
          numScroll: 1,
        },
      ],
    };
  },
  props: {
    contentInfo: {
      type: Array,
      required: true,
    },
  },
};
</script>
